import {
  Button,
  Container,
  Fab,

  makeStyles,
  Modal,
  Snackbar,
  TextField,
  Tooltip,
} from "@material-ui/core";
// import Files from "react-files";
import { Add as AddIcon } from "@material-ui/icons";
import React, {  useState } from "react";
import MuiAlert from "@material-ui/lab/Alert";
import { useDispatch, useSelector } from "react-redux";

import { addNewFamily } from "../reduxSaga/actions";
import getCurrentUserId from "../reduxSaga/sagas/requests/currentUserId";

// import {
//   getAllWarehousesManager,

//   addNewRealWarehouse,
// } from "../reduxSaga/actions";

const useStyles = makeStyles((theme) => ({
  fab: {
    position: "fixed",
    bottom: 20,
    right: 20,
  },
  container: {
    borderRadius: 10,
    boxShadow: "0 3px 5px 2px rgba(18,131,255,0.87)",
    width: 500,
    height: 300,
    backgroundColor: "white",
    position: "absolute",
    top: -30,
    bottom: 0,
    left: 0,
    right: 0,
    margin: "auto",
    [theme.breakpoints.down("sm")]: {
      width: "100vw",
      height: "100vh",
    },
  },
  form: {
    padding: theme.spacing(2),
  },
  item: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(3),
  },

  cancelAndAddButtom: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(5),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  input: {
    "&::placeholder": {
      fontStyle: "italic",
    },
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const AddFamily = ({ setOnAddFamily }) => {
  const dispatch = useDispatch();
  // const familyNotification = useSelector(
  //   (state) => state.staff.familyNotification
  // );

  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [openAlert, setOpenAlert] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  const [name, setName] = useState();
  const [desc, setDesc] = useState();

  /*useEffect(() => {
      {
        if (brandNotification == "success" ) {
          setErrorAlertText("Erreur :le champ du non est vide ! ");
          setOpenErrorAlert(true);
          dispatch(setBrandNotificationState());
          setOnAddFamily(false);
        } 
      }
    }, [brandNotification]);*/

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert(false);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const onChangeName = (event) => {
    setName(event.target.value);
  };

  const onChangeDesc = (event) => {
    setDesc(event.target.value);
  };

  const onCancelButtonHandler = () => {
    setOpen(false);
    setOnAddFamily(false);
  };

  const onAddFamily = () => {
    if (name == null) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur :le champ du nom est vide ! ");
    } else {
      console.log(name, desc);
      let familyModel = {
        familyName: name,
        description: desc,
        idUserCreation: getCurrentUserId(),
        type: 1,
      };

      dispatch(addNewFamily(familyModel));
      // setOpenErrorAlert(true);
      // setErrorAlertText("success :le champ du non est vide ! ");
      setTimeout(setOnAddFamily(false), 5000);
      setOnAddFamily(false);
    }
  };

  //   const onCreateHandler = () => {
  //     // setOpenAlert(true);
  //     if (reference == null) {
  //       setOpenErrorAlert(true);
  //       setErrorAlertText("Erreur :le champ du référence est vide ! ");
  //     } else if (name == null) {
  //       setOpenErrorAlert(true);
  //       setErrorAlertText("Erreur :le champ du nom  est vide ! ");
  //     } else {
  //       let warehouseModel = {
  //         name: name,
  //         ref: reference,
  //         idManager: warehouseManager,
  //         idUser: 0,
  //         description: desc,
  //       };
  //       dispatch(addNewRealWarehouse(warehouseModel));
  //       if (warehouseError != null) {
  //         setErrorAlertText("Erreur :il ya un problem de connection ");
  //         setOpenErrorAlert(true);
  //       } else if (realWarehouse.success) {
  //         setOpenAlert(true);
  //         setTimeout(onCancelButtonHandler, 1000);
  //       } else {
  //         setErrorAlertText(
  //           "Erreur :  le type de responsable est invalide  ou il ya un problem de connection "
  //         );
  //       }
  //     }
  //   };
  return (
    <>
      <Tooltip title="Add" aria-label="add" onClick={() => setOpen(true)}>
        <Fab color="primary" className={classes.fab}>
          <AddIcon />
        </Fab>
      </Tooltip>
      <Modal open={open}>
        <Container className={classes.container}>
          <form className={classes.form} autoComplete="off">
            <div className={classes.item}>
              <TextField
                required
                placeholder="Taper le nom  de famille "
                id="standard-basic"
                label=" Taper le nom de famille "
                variant="outlined"
                size="small"
                style={{ width: "100%" }}
                onChange={onChangeName}
                InputProps={{
                  classes: { input: classes.input },
                }}
              />
            </div>
            <div className={classes.item}>
              <TextField
                id="outlined-multiline-static"
                multiline
                rows={4}
                InputProps={{
                  classes: { input: classes.input },
                }}
                placeholder="Note"
                variant="outlined"
                label="Note"
                size="small"
                style={{ width: "100%" }}
                onChange={onChangeDesc}
              />
            </div>

            <div className={classes.cancelAndAddButtom}>
              <Button
                variant="outlined"
                color="primary"
                style={{ marginRight: 20 }}
                onClick={onAddFamily}
              >
                Create
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                onClick={onCancelButtonHandler}
              >
                Cancel
              </Button>
            </div>
          </form>
        </Container>
      </Modal>
      <Snackbar
        open={openAlert}
        autoHideDuration={4000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleClose} severity="success">
          Ajout avec success !
        </Alert>
      </Snackbar>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={4000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </>
  );
};

export default AddFamily;
